import styles from "./Footer.module.scss";
import logo from "../images/logo_inverted.svg";
import cn from "classnames";
import { Col, Row } from "react-grid-system";
import { Link, useNavigate, useLocation } from "react-router-dom";

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
  <section className={styles.main}>
    <footer className={cn(styles.footer, "mainWrapper")}>
      <Row>
        <Col>
          <ul className={styles.listPrimary}>
            <li>
              <img className={styles.logo} src={logo} alt="Gallur Montesinos" />
            </li>
            <li className={styles.listTitle}>
              <p>Abogado</p>
              <p>Administración de Fincas</p>
              <p>Asesoría</p>
            </li>
            <li>
              Calle Poeta Zorrilla 10, local
              <br />
              03610, Petrer (Alicante)
            </li>
            <li>© 2023 Gallur Montesinos</li>
            <li>
              <Link to="/privacidad" style={{ color: "inherit", textDecoration: "none" }}>Política de Privacidad</Link>
            </li>
            <li>
              <Link to="/cookies" style={{ color: "inherit", textDecoration: "none" }}>Política de Cookies</Link>
            </li>
            <li>
              <Link to="/legal" style={{ color: "inherit", textDecoration: "none" }}>Aviso Legal</Link>
            </li>
          </ul>
        </Col>
        <Col md={3}>
          <ul className={styles.listSecondary}>
            <li className={styles.listTitle}>Contacto</li>
            <li className={styles.iconPhone}>865 710 494</li>
            <li className={styles.iconPhone}>617 403 666</li>
            <li className={styles.iconMessage}>info@gallurmontesinos.com</li>
          </ul>
        </Col>
        <Col md={3}>
          <ul className={styles.listSecondary}>
            <li className={styles.listTitle}>Secciones</li>
            <li>
              <a onClick={() => handleScroll("header")}>Inicio</a>
            </li>
            <li>
              <a onClick={() => handleScroll("services")}>Nuestros servicios</a>
            </li>
            <li>
              <a onClick={() => handleScroll("about")}>Quienes somos</a>
            </li>
            <li>
              <a onClick={() => handleScroll("team")}>Equipo</a>
            </li>
            <li>
              <a onClick={() => handleScroll("contact")}>Contacto</a>
            </li>
          </ul>
        </Col>
      </Row>
    </footer>
  </section>
  );
};
